import { Injector } from "@angular/core";
import { DateHelperByDateFns, DateHelperByDatePipe, DateHelperService } from "ng-zorro-antd/i18n";
import dayjs from "@gtmhub/dayjs";
import { UiI18nService } from "@webapp/ui/i18n/services/i18n.service";
import { UiDateConfig, UiDateMaxMin } from "../date-picker.models";

export function DateHelperServiceFactory(injector: Injector, config: UiDateConfig): DateHelperService {
  const i18n = injector.get(UiI18nService);
  return i18n.getDateLocale() ? new DateHelperByDateFns(i18n, config) : new DateHelperByDatePipe(i18n, config);
}

export function shouldDisableMaxMinDate(date: Date, dateOptions: UiDateMaxMin): boolean {
  const dueDate = dayjs(date).startOf("day");

  const { maxDate, minDate } = dateOptions;

  const minDateCheck = minDate ? dueDate.isBefore(dayjs(minDate).startOf("day")) : false;
  const maxDateCheck = maxDate ? dueDate.isAfter(dayjs(maxDate).endOf("day")) : false;

  return minDateCheck || maxDateCheck;
}
